import templateUrl from './confirmation-form.component.html';
import { StateService } from 'angular-ui-router';

export const ConfirmationFormComponent = {
    templateUrl,
    controller: ConfirmationFormController,
    controllerAs: "vm",
    bindings: {
        resolve: "<",
        ownerView:"<",
        employee: "<",
        employeeProfile: "<",
        profile: "<",
        employeeBankInfo: "<",
        provinces: "<",
        application: "<",
        genderOptions: "<",
        close: "&",
        dismiss: "&"
    }
};


function ConfirmationFormController(onboardingDocumentViewService, onboardingDocumentService, $state: StateService, employeeService, utilityService) {
    'ngInject';
    const vm = this;
    vm.confirmationForm;
    vm.editForm = {};
    vm.onShowDirectDeposit = onShowDirectDeposit;
    vm.onConfirmChange = onConfirmChange;
    vm.onClose = onClose;
    vm.state = {
        view: 'Confirmation'
    };
    vm.onSubmit = onSubmit;
    vm.isSubmitted = false;

    vm.$onInit = function () {
        if (vm.resolve) {
            Object.assign(vm, vm.resolve);
        }

    }

    function onConfirmChange() {
        if (vm.confirmationForm.declaration) {
            vm.conForm.declaration.$setValidity('missing', true);
        } else {
            vm.conForm.declaration.$setValidity('missing', false);
        }
    }

    function onShowDirectDeposit() {
        return $state.go("onboarding-document.directdeposit");
    }

    function onShowApplications() {
        vm.close({ $value: 'ok' });
    }

    //function submitApplication() {
    //    console.log('Testing');
    //    $state.go('/application-status');
    //}

    function onSubmit() {
        utilityService.showLoading();
        vm.isSubmitted = true;
        if (!vm.confirmationForm.declaration) {
            utilityService.hideLoading();
            return;
        }
        return onboardingDocumentService.submitApplication(vm.employee.EmployeeID).then(function (isConfirmed) {
            if (isConfirmed === true) {
                onShowApplications();
            } else {
                alert('Confirmation failed!');
            }
        }).catch((err) => {
            utilityService.hideLoading();
            alert(err);
        });


    }

    function onClose() {
        vm.close({ $value: 'cancel' });
    }
}



export const ConfirmationModal = {
    component: "apexConfirmationModal",
    windowClass: 'xx-dialog pagespinner',
    size: 'sm',
    backdrop: 'static'
}
